
<template>
  <v-navigation-drawer app touchless temporary v-model="chatDrawer" :stateless="dialog" persistent right enable-resize-watcher mobile-breakpoint="10240" :width="$vuetify.breakpoint.width>450?450:$vuetify.breakpoint.width">
    <v-app-bar tile fixed color="transparent">
      <v-app-bar-nav-icon @click="closeChat">
        <v-icon>close</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title class="title font-weight-bold">Chat with {{selectedGroup.name|formatName}}</v-toolbar-title>
    </v-app-bar>
    <v-row no-gutters :style="`margin-top:${$vuetify.breakpoint.width>1023?64:56}px`">
      <v-col cols="2" class="pt-2">

        <v-row justify="center" v-for="(item) in avatars" :key="item.profileId" @click="changeGroup(item)" style="border-top-left-radius: 5px;border-bottom-left-radius: 5px;" :class="selectedGroup.profileId===item.profileId?$vuetify.theme.dark?'grey':'grey lighten-2':''">
          <v-col cols="12" align="center" class="pb-1 pl-4">
            <v-badge color="red" right dot overlap v-if="item.profileId === 'All'" :value="(((warnings || {}).All || {})[currentUser.uid] || false)">
              <template v-slot:badge>
                <span>
                  !
                </span>
              </template>
              <v-avatar size="36" class="primary " style="cursor: pointer">
                <v-icon color="white">{{item.avatar}}</v-icon>
              </v-avatar>
            </v-badge>

            <v-badge color="red" right dot overlap v-if="item.profileId !== 'All'" :value="(((((warnings || {})[currentUser.uid] || []).badge||[])[item.profileId] || false)||((((warnings || {})[currentUser.uid] || []).badge||[])[item.hefeId] || false))">
              <template v-slot:badge>
                <span>
                  !
                </span>
              </template>
              <v-avatar size="36" class="primary" style="cursor: pointer">
                <img :src="item.avatar" :alt="item.name">
              </v-avatar>
            </v-badge>
            <v-avatar v-else size="36" class="primary" style="cursor: pointer">
              <img :src="item.avatar" :alt="item.name">
            </v-avatar>
            <v-row no-gutters justify="center">
              <span :class="$vuetify.theme.dark?selectedGroup.profileId===item.profileId?'caption black--text':'caption':' caption'">{{item.name|formatName}}</span>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="10">
        <div class="chat-container mr-2 mt-2" ref="chat-container" :key="index" :class="$vuetify.theme.dark?'grey':'grey lighten-2'" :style="`height:${$vuetify.breakpoint.width>1023?$vuetify.breakpoint.height-138:$vuetify.breakpoint.height-122}px;box-sizing: border-box;overflow-y: auto;background-color: #f2f2f2;overflow-x: hidden;border-radius:5px`">
          <template v-for="(item,q) in messages">
            <message :message="item" :avatar="selectedGroup.avatar" :is-hefe="chatSelection.isHefe" v-if="item!==currentUser.uid" :key="q"></message>
          </template>
          <v-list-item dense>
            <span v-if="((((warnings || {})[currentUser.uid] || []).typing||[])[selectedGroup.profileId]||(((warnings || {})[currentUser.uid] || []).typing||[])[selectedGroup.hefeId] || false)">
              <div class='spinner'>
                <div class='bounce1'></div>
                <div class='bounce2'></div>
                <div class='bounce3'></div>
              </div>
            </span>
          </v-list-item>

        </div>
      </v-col>
    </v-row>

    <v-app-bar color="transparent" flat tile>
      <v-btn color="info" fab small text class="mr-4" @click="photoOverlay = true">
        <v-icon large>mdi-camera-plus</v-icon>
      </v-btn>
      <v-text-field dense outlined maxlength="150" hide-details append-icon v-model="messageText" :placeholder="`${$language.jobDetails['Say something!']} ${selectedGroup.profileId==='All'?'everyone':formatName(selectedGroup.name)}`" @keyup.enter="() =>sendMessage(null) " @keydown="typing">
        <template v-slot:append>
          <emoji-picker @insert="insertEmoji"></emoji-picker>
        </template>
      </v-text-field>
      <v-btn color="info" fab small class="ml-2" @click="sendMessage(null)" :disabled="messageText===null">
        <v-icon>send</v-icon>
      </v-btn>
    </v-app-bar>
    <v-fade-transition>
      <v-overlay :dark="$vuetify.theme.dark" absolute color="black" v-show="photoOverlay">
        <v-card :max-width="$vuetify.breakpoint.xs ? 232 : $vuetify.breakpoint.sm ? 282 : 332">
          <v-row>
            <v-col cols="12" justify="center" align="center">
              <croppa ref="myCroppa" :width="$vuetify.breakpoint.xs ? 200 : $vuetify.breakpoint.sm ? 250 : 300" :height="$vuetify.breakpoint.xs ? 200 : $vuetify.breakpoint.sm ? 250 : 300" :placeholder="$language.registration['Add a photo']" :placeholder-font-size="22" :disabled="false" :prevent-white-space="true" :show-remove-button="true" :accept="'image/*'" @new-image-drawn="detectFiles" @file-choose="initial = false">
              </croppa>
            </v-col>
            <v-col cols="12" align="center">
              <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(-1)">
                <v-icon large>rotate_left</v-icon>
              </v-btn>
              <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(1)">
                <v-icon large>rotate_right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row no-gutters  justify="space-around" class="px-2">
              <v-col cols="5">
                <v-btn text @click.native="photoOverlay = false" block large color="primary">Cancel</v-btn>
              </v-col>
              <v-col cols="5">
                <v-btn @click="generateBlob" color="primary" block large :disabled="!uploadReady">Upload</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-overlay>
    </v-fade-transition>
  </v-navigation-drawer>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import {
  object
} from 'rxfire/database'
import {
  map
} from 'rxjs/operators'
import EmojiPicker from '@/components/common/chat/EmojiPicker'
import Message from '@/components/common/chat/Message'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    Message,
    EmojiPicker
  },
  props: [],
  data () {
    return {
      chatDrawer: false,
      messageText: null,
      messageGroup: {},
      avatars: {},
      selectedGroup: {
        profileId: null
      },
      messageList: [],
      myMessageList: [],
      warnings: {},
      index: 0,
      messageSub: null,
      messageSub2: null,
      photoOverlay: false,
      picture: null,
      dialog: true,
      uploadReady: false
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'chatOpen', 'chatSelection']),
    messages () {
      if (this.chatSelection.isHefe) {
        return Object.values((this.messageList || {})[this.selectedGroup.profileId] || {}).map(k => k)
      } else {
        return Object.values(this.myMessageList || {}).map(k => k)
      }
    }
  },
  mounted: function () {
  },
  destroyed () {
    if (this.chatSelection.isHefe) {
      this.messageSub.unsubscribe()
      this.warnSub.unsubscribe()
    } else {
      this.messageSub2.unsubscribe()
      this.warnSub.unsubscribe()

      // this.groupMessageSub.unsubscribe()
    }
  },
  methods: {
    detectFiles () {
      this.uploadReady = true
    },
    generateBlob () {
      var blob = this.$refs.myCroppa.generateDataUrl('image/jpeg', 0.5)
      this.photoOverlay = false
      this.$refs.myCroppa.remove()
      this.sendMessage(blob)
      this.uploadReady = false
    },
    rotatePhoto (dir) {
      this.$refs.myCroppa.rotate(dir)
    },

    closeChat () {
      this.$store.commit('setChatOpen', false)
      this.avatars = {}
      this.selectedGroup = {}
      this.messageList = []
      this.myMessageList = []
      this.warnings = {}
      if (this.chatSelection.isHefe) {
        this.messageSub.unsubscribe()
      } else {
        this.messageSub2.unsubscribe()
        // this.groupMessageSub.unsubscribe()
      }
      this.warnSub.unsubscribe()
    },
    // Add selected emoji in input
    insertEmoji (emoji) {
      this.messageText = this.messageText === null ? this.messageText = emoji : this.messageText += emoji
    },
    sendMessage (picture) {
      var updates = {}
      var newKey = fb.database.ref().child(`messages/${this.chatSelection.jobId}/messages/${this.selectedGroup.profileId}`).push().key
      var message = {
        'messageText': this.messageText,
        'profileId': this.currentUser.uid,
        'timeStamp': new Date(),
        'avatar': this.userProfile.public.photoURL,
        'picture': picture || {}
      }

      this.messageText = null
      updates[`messages/${this.chatSelection.jobId}/messages/${this.selectedGroup.profileId}/${newKey}`] = message
      if (this.selectedGroup.hefe) {
        updates[`messages/${this.chatSelection.jobId}/warnings/${this.selectedGroup.hefeId}/badge/${this.currentUser.uid}`] = true
        updates[`user/${this.selectedGroup.hefeId}/jobs/${this.chatSelection.jobId}/showMessageWarning`] = true
        updates[`messages/${this.chatSelection.jobId}/warnings/${this.selectedGroup.hefeId}/typing/${this.currentUser.uid}`] = false
      } else {
        updates[`messages/${this.chatSelection.jobId}/warnings/${this.selectedGroup.profileId}/badge/${this.currentUser.uid}`] = true
        updates[`user/${this.selectedGroup.profileId}/jobs/${this.chatSelection.jobId}/showMessageWarning`] = true
        updates[`messages/${this.chatSelection.jobId}/warnings/${this.selectedGroup.profileId}/typing/${this.currentUser.uid}`] = false
      }
      updates[`messages/${this.chatSelection.jobId}/warnings/${this.currentUser.uid}/badge/${this.selectedGroup.profileId}`] = null

      fb.database.ref().update(updates)
      this.$nextTick(() => {
        this.scrollToEnd()
      })
    },
    changeGroup (group) {
      this.selectedGroup = group
      this.$nextTick(() => {
        this.index += this.index
        this.scrollToEnd()
      })
    },
    scrollToEnd () {
      this.$nextTick(() => {
        var container = this.$el.querySelector('.chat-container')
        if (container !== null) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    typing () {
      clearTimeout(this._timerId)
      var updates = {}
      if (this.selectedGroup.hefe) {
        updates[`messages/${this.chatSelection.jobId}/warnings/${this.selectedGroup.hefeId}/typing/${this.currentUser.uid}`] = true
      } else {
        updates[`messages/${this.chatSelection.jobId}/warnings/${this.selectedGroup.profileId}/typing/${this.currentUser.uid}`] = true
      }
      fb.database.ref().update(updates)
      this.scrollToEnd()

      this._timerId = setTimeout(() => {
        var updates = {}

        if (this.selectedGroup.hefe) {
          updates[`messages/${this.chatSelection.jobId}/warnings/${this.selectedGroup.hefeId}/typing/${this.currentUser.uid}`] = false
        } else {
          updates[`messages/${this.chatSelection.jobId}/warnings/${this.selectedGroup.profileId}/typing/${this.currentUser.uid}`] = false
        }
        fb.database.ref().update(updates)
      }, 3000)
    },
    formatName (val) {
      if (val === 'Hefe') {
        return 'Hefe'
      }
      var str = (val || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    }
  },
  watch: {
    messages () {
      this.$nextTick(() => {
        this.index += this.index
        this.scrollToEnd()
      })
    },
    chatOpen () {
      this.chatDrawer = this.chatOpen.open
    },
    chatSelection () {
      if (this.chatSelection.isHefe) {
        fb.database.ref(`jobs/${this.chatSelection.jobId}/applicants`).once('value').then((snapshot) => {
          var applicants = snapshot.val()
          this.avatars = Object.keys(applicants || {}).map(k => {
            return {
              profileId: (applicants[k] || {}).profileId,
              avatar: (applicants[k] || {}).avatar,
              name: (applicants[k] || {}).name
            }
          })
          this.selectedGroup = this.avatars[0]
        })
        this.messageSub = object(fb.database.ref(`messages/${this.chatSelection.jobId}/messages`))
          .pipe(map(change => ({
            _key: change.snapshot.key,
            ...change.snapshot.val()
          })))
          .subscribe(messages => {
            this.messageList = messages
          })
      } else {
        fb.database.ref(`jobs/${this.chatSelection.jobId}/public`).once('value').then((snapshot) => {
          var hefe = snapshot.val()
          this.avatars = [{
            profileId: this.currentUser.uid,
            avatar: hefe.hefeAvatar,
            name: hefe.hefeName,
            hefe: true,
            hefeId: hefe.createdBy
          }]
          this.selectedGroup = this.avatars[0]
        })
        this.messageSub2 = object(fb.database.ref(`messages/${this.chatSelection.jobId}/messages/${this.currentUser.uid}`))
          .pipe(map(change => ({
            _key: change.snapshot.key,
            ...change.snapshot.val()
          })))
          .subscribe(messages => {
            this.myMessageList = messages

            this.index += this.index
          })
      }

      this.warnSub = object(fb.database.ref(`messages/${this.chatSelection.jobId}/warnings`))
        .pipe(map(change => ({
          _key: change.snapshot.key,
          ...change.snapshot.val()
        })))
        .subscribe(warnings => {
          var updates = {}
          updates[`user/${this.currentUser.uid}/jobs/${this.chatSelection.jobId}/showMessageWarning`] = false
          if (this.selectedGroup.hefe) {
            updates[`messages/${this.chatSelection.jobId}/warnings/${this.currentUser.uid}/badge/${this.selectedGroup.hefeId}`] = null
          } else {
            updates[`messages/${this.chatSelection.jobId}/warnings/${this.currentUser.uid}/badge/${this.selectedGroup.profileId}`] = null
          }
          fb.database.ref().update(updates)

          this.warnings = warnings
        })
    },
    selectedGroup () {
      var updates = {}
      if ((this.selectedGroup || {}).hefe || false) {
        updates[`messages/${this.chatSelection.jobId}/warnings/${this.currentUser.uid}/badge/${this.selectedGroup.hefeId}`] = null
      } else {
        updates[`messages/${this.chatSelection.jobId}/warnings/${this.currentUser.uid}/badge/${this.selectedGroup.profileId}`] = null
      }
      fb.database.ref().update(updates)
    }

  },

  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatTime (val) {
      if (!val) {
        return '-'
      }
      return moment(val, ['HH.mm']).format('hh:mm a')
    },
    formatName (val) {
      if (val === 'Hefe') {
        return 'Hefe'
      }
      var str = (val || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    }
  }
}
</script>

<style >
.messages {
  flex-grow: 1;
  margin-bottom: 68px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  min-height: 0;
  background-color: #f2f2f2;
}
.spinner {
  margin: 0;
  width: 30px;
  text-align: center;
  color: green;
}

.spinner > div {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  background: rgb(53, 53, 53);
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
